/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/134-binoculars': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M1 0h6v1H1zm8 0h6v1H9zm5.875 5H14V1h-4v4H6V1H2v4h-.875C.506 5 0 5.506 0 6.125v8.75C0 15.494.506 16 1.125 16h4.75C6.494 16 7 15.494 7 14.875V9h2v5.875C9 15.494 9.506 16 10.125 16h4.75c.619 0 1.125-.506 1.125-1.125v-8.75C16 5.506 15.494 5 14.875 5zM5.438 15H1.563C1.254 15 1 14.775 1 14.5s.253-.5.563-.5h3.875c.309 0 .563.225.563.5s-.253.5-.563.5zM8.5 8h-1c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h1c.275 0 .5.225.5.5s-.225.5-.5.5zm5.938 7h-3.875c-.309 0-.563-.225-.563-.5s.253-.5.563-.5h3.875c.309 0 .563.225.563.5s-.253.5-.563.5z"/>'
  }
})
